import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = "Sheva Studio - Konya'nın En İyi Nail Art Stüdyosu",
  description = "Sheva’da güzelliğin en özel dokunuşlarını keşfedin – Nail art’tan makyaja, çok daha fazlası burada!",
  keywords = "nail art, manikür, jel oje, protez tırnak, tırnak tasarımı, güzellik salonu, konya nail art",
  canonical,
  ogImage = "/logo512.png",
  ogType = "website",
  twitterCard = "summary_large_image"
}) => {
  const baseUrl = "https://shevastudiokonya.com";
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;

  return (
    <Helmet>
      {/* Temel Meta Tag'ler */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:site_name" content="Sheva Studio" />
      <meta property="og:locale" content="tr_TR" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
      
      {/* Ek SEO Meta Tag'ler */}
      <meta name="author" content="Sheva Studio" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Turkish" />
      <meta name="geo.region" content="TR-42" />
      <meta name="geo.placename" content="Konya" />
      <meta name="geo.position" content="37.8667;32.4833" />
      <meta name="ICBM" content="37.8667, 32.4833" />
      
      {/* Yapılandırılmış Veri */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BeautySalon",
          "name": "Sheva Studio",
          "description": description,
          "url": baseUrl,
          "telephone": "+90-332-XXX-XXXX",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Konya Merkez",
            "addressLocality": "Konya",
            "addressRegion": "Konya",
            "postalCode": "42000",
            "addressCountry": "TR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 37.8667,
            "longitude": 32.4833
          },
          "openingHours": [
            "Mo-Fr 09:00-18:00",
            "Sa 09:00-18:00",
            "Su 11:00-18:00"
          ],
          "priceRange": "₺₺",
          "image": fullOgImage,
          "sameAs": [
            "https://www.instagram.com/shevastudio",
            "https://www.facebook.com/shevastudio"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
